<template>
  <div style="overflow: hidden">
    <div class="title">基本信息</div>
    <div class="content">
      <div class="cell" id="company">
        <span>公司</span>
        <input type="text" placeholder="请输入公司名称" v-model="company" />
      </div>
      <div class="cell" id="name">
        <span>联系人</span>
        <input type="text" placeholder="请输入联系人姓名" v-model="name" />
      </div>
      <div class="cell" id="job">
        <span>职务</span>
        <input type="text" placeholder="请输入联系人职务" v-model="job" />
      </div>
      <div class="cell" id="phone">
        <span>手机号</span>
        <input
          type="text"
          placeholder="请输入联系人手机号"
          maxlength="11"
          v-model="phone"
        />
      </div>
      <div class="cell" id="email">
        <span>邮箱</span>
        <input type="text" placeholder="请输入联系人邮箱" v-model="Email" />
      </div>
      <div class="cell" id="address">
        <span>地址</span>
        <input type="text" placeholder="请输入地址" v-model="address" />
      </div>
      <div class="cell" id="creditCode">
        <span>社会信用代码</span>
        <input
          type="text"
          placeholder="请输入社会信用代码"
          v-model="creditCode"
        />
      </div>
    </div>

    <div class="title" style="padding-top: 20px" id="exhibitionarea">
      展会选择
    </div>
    <div class="exhibitionarea">
      <div
        class="exhibition1"
        v-for="(item, index) in exhibitionList"
        :key="index + '1'"
        :class="{ is_active: index == exIndex }"
        @click="changeEx(item.id, index)"
      >
        <span class="span1">{{ item.name }} / {{ item.shortName }}</span>
      </div>
    </div>
    <div class="title">展区选择</div>
    <div class="exhibitionarea" id="booth" v-if="exhibitionArea.length">
      <div v-for="(item, index) in exhibitionArea" :key="index + '1'">
        <div
          class="exhibition1"
          :class="{ is_active: index == exAreaIndex }"
          @click="changeExArea(item.id, index, item.name)"
          v-if="item.typeLanguage == '中文'"
        >
          <span class="span1">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="loadingText" v-else>加载中....</div>
    <Input
      v-model="remark"
      placeholder="请输入产品类型"
      v-if="inputShow"
      style="width: 4rem; margin: 0 0 0.3rem 0.3rem"
    />
    <div class="title">展位预定</div>
    <div v-for="(item3, index3) in exhibitionBooth" :key="index3">
      <div class="reserve">
        <div style="padding: 0.36rem 0">
          <Checkbox
            v-model="item3.isCheck"
            :label="item3.pjName"
            @on-change="changeBox(item3, $event, index3)"
          ></Checkbox>

          <span class="reserve_span1">{{ item3.pjName }}</span>
          <span class="reserve_span2" v-if="item3.remarkList.length > 0">{{
            item3.remarkList[0]
          }}</span>
          <span class="reserve_span3" v-if=""
            >{{ item3.price }}{{ item3.pType }}/{{ item3.cunit }}</span
          >
        </div>

        <div
          v-if="item3.remarkList[1]"
          style="font-size: 0.26rem; margin-left: 0.3rem; color: red"
        >
          {{ item3.remarkList[1] }}
        </div>
        <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>

        <!--展位面积-->
        <div class="area" v-if="item3.isCheck">
          <span class="area-title">展位面积</span>
          <div style="margin-top: 0.36rem">
            <span style="font-size: 0.24rem">面宽</span>
            <Input
              v-model="item3.Width"
              style="width: 1.4rem; margin: 0 0.1rem"
              @on-change="exwidth(item3.Width)"
              maxlength="4"
              type="number"
            />
            <span style="margin-right: 0.5rem">米</span>
            <span style="margin-right: 0.5rem">X</span>
            <span style="font-size: 0.24rem">进深</span>
            <Input
              v-model="item3.Height"
              style="width: 1.4rem; margin: 0 0.1rem"
              @on-change="exheight(item3.Height)"
              maxlength="4"
              type="number"
            />
            <span style="font-size: 0.24rem">米</span>
          </div>
          <div style="margin-top: 0.3rem; padding-bottom: 0.5rem">
            <span style="font-size: 0.24rem">面积</span>
            <div
              style="
                display: inline-block;
                width: 1.4rem;
                height: 0.64rem;
                background-color: #f2f2f2;
                border-radius: 0.1rem;
                border: solid 1px #cccccc;
                line-height: 0.64rem;
                padding-left: 4px;
                margin: 0 0.1rem;
              "
            >
              {{ item3.Width * item3.Height }}
            </div>
            <span>平米</span>
          </div>
          <div class="total">
            <span
              v-if="
                item3.standstall > 1 &&
                (item3.cunit.indexOf('㎡') != -1 ||
                  item3.cunit.indexOf('平米') != -1 ||
                  item3.cunit.indexOf('平方米') != -1)
              "
              >合计：{{
                (
                  (item3.Width * item3.Height * item3.price) /
                  item3.standstall
                ).toFixed()
              }}{{ item3.pType }}</span
            >
            <span v-else
              >合计：{{ item3.Width * item3.Height * item3.price }}
              {{ item3.pType }}</span
            >
          </div>
          <div
            style="width: 100%; height: 1px; background-color: #e5e5e5"
          ></div>
        </div>
      </div>
    </div>

    <div class="title">固定费用</div>
    <div>
      <div
        class="exhibition1"
        v-for="(other, index) in otherList"
        :key="index + '1'"
      >
        <div class="reserve">
          <div style="padding: 0.36rem 0">
            <Checkbox
              v-model="other.isCheck"
              :label="other.pjName"
              :disabled="true"
            ></Checkbox>

            <span class="reserve_span1">{{ other.pjName }}</span>
          </div>
        </div>

        <div class="table">
          <div class="table-child">
            单价:
            <span style="color: red"
              >{{ other.price }}{{ other.pType }}/{{ other.cunit }}</span
            >
          </div>
          <div class="table-child">
            个数
            <div
              style="
                display: inline-block;
                width: 1.4rem;
                height: 0.64rem;
                background-color: #f2f2f2;
                border-radius: 0.1rem;
                border: solid 1px #cccccc;
                line-height: 0.64rem;
                padding-left: 4px;
                margin: 0 0.1rem;
              "
            >
              {{ other.minCount }}
            </div>
            {{ other.cunit }}
          </div>
          <div class="table-child">
            总价: {{ other.minCount * other.price }} {{ other.pType }}
          </div>
        </div>

        <div style="width: 100%; height: 1px; background-color: #e5e5e5"></div>
      </div>
    </div>
    <div class="title" v-if="onlineList.length > 0">
      请选择线上市场增值服务项目
    </div>
    <div>
      <div
        class="exhibition1"
        v-for="(online, index) in onlineList"
        :key="index + '1'"
      >
        <div v-if="online.typeLanguage == '中文'">
          <div
            v-for="(onlineChild, index1) in online.dePjNameList"
            :key="index1 + '1'"
          >
            <div class="reserve">
              <div style="padding: 0.36rem 0">
                <Checkbox
                  v-model="onlineChild.isCheck"
                  :label="onlineChild.pjName"
                  @on-change="onlineChange(onlineChild, $event)"
                ></Checkbox>

                <span class="reserve_span1">{{ onlineChild.pjName }}</span>
              </div>
            </div>

            <div class="table">
              <div class="table-child">
                <span v-if="onlineChild.durationType === '时间段'"
                  >输入时间段：</span
                >
                <span v-if="onlineChild.durationType === '时长'"
                  >选择时长：</span
                >
                <div v-if="onlineChild.durationType === '时间段'">
                  <span>开始时间：</span>
                  <Input
                    v-model="onlineChild.beginTime"
                    style="width: 2rem; margin: 0 0.1rem; font-size: 0.24rem"
                    type="text"
                  />
                  示例(2021-05-13)
                </div>
                <div
                  style="margin-top: 0.2rem"
                  v-if="onlineChild.durationType === '时间段'"
                >
                  <span>结束时间：</span>
                  <Input
                    v-model="onlineChild.endTime"
                    style="width: 2rem; margin: 0 0.1rem; font-size: 0.24rem"
                    type="text"
                  />
                </div>
                <template v-if="onlineChild.durationType === '时长'">
                  <Select
                    v-model="onlineChild.durationValue"
                    style="width: 2rem"
                    @click.stop.native
                  >
                    <Option
                      v-for="im in onlineChild.durationList"
                      :value="im"
                      :key="im"
                      >{{ im }}</Option
                    > </Select
                  >&nbsp;&nbsp;&nbsp;{{ onlineChild.durationUnit }}
                </template>
              </div>
              <div class="table-child">
                单价:
                <span style="color: red"
                  >{{ onlineChild.price }}{{ onlineChild.pType }}/{{
                    onlineChild.cunit
                  }}</span
                >
              </div>
              <div class="table-child">
                个数
                <Input
                  v-model="onlineChild.orderNum"
                  style="width: 1.4rem; margin: 0 0.1rem"
                  @on-change="changeNumber(onlineChild)"
                  maxlength="4"
                  type="number"
                />
                {{ onlineChild.cunit }}
              </div>
              <div class="table-child">
                总价: {{ onlineChild.orderNum * onlineChild.price }}
                {{ onlineChild.pType }}
              </div>
            </div>

            <div
              style="width: 100%; height: 1px; background-color: #e5e5e5"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="title" v-if="offlineList.length > 0">
      请选择线下市场增值服务项目
    </div>
    <div>
      <div
        class="exhibition1"
        v-for="(offline, index) in offlineList"
        :key="index + '1'"
      >
        <div v-if="offline.typeLanguage == '中文'">
          <div
            v-for="(offlineChild, index1) in offline.dePjNameList"
            :key="index1 + '1'"
          >
            <div class="reserve">
              <div style="padding: 0.36rem 0">
                <Checkbox
                  v-model="offlineChild.isCheck"
                  :label="offlineChild.pjName"
                  @on-change="offlineChange(offlineChild, $event)"
                ></Checkbox>

                <span class="reserve_span1">{{ offlineChild.pjName }}</span>
              </div>
            </div>

            <div class="table">
              <div class="table-child">
                <span v-if="offlineChild.durationType === '时间段'"
                  >输入时间段：</span
                >
                <span v-if="offlineChild.durationType === '时长'"
                  >选择时长：</span
                >
                <div v-if="offlineChild.durationType === '时间段'">
                  <span>开始时间：</span>
                  <Input
                    v-model="offlineChild.beginTime"
                    style="width: 2rem; margin: 0 0.1rem; font-size: 0.24rem"
                    type="text"
                  />
                  示例(2021-05-13)
                </div>
                <div
                  style="margin-top: 0.2rem"
                  v-if="offlineChild.durationType === '时间段'"
                >
                  <span>结束时间：</span>
                  <Input
                    v-model="offlineChild.endTime"
                    style="width: 2rem; margin: 0 0.1rem; font-size: 0.24rem"
                    type="text"
                  />
                </div>
                <template v-if="offlineChild.durationType === '时长'">
                  <Select
                    v-model="offlineChild.durationValue"
                    style="width: 2rem"
                    @click.stop.native
                  >
                    <Option
                      v-for="im in offlineChild.durationList"
                      :value="im"
                      :key="im"
                      >{{ im }}</Option
                    > </Select
                  >&nbsp;&nbsp;&nbsp;{{ offlineChild.durationUnit }}
                </template>
              </div>
              <div class="table-child">
                单价:
                <span style="color: red"
                  >{{ offlineChild.price }}{{ offlineChild.pType }}/{{
                    offlineChild.cunit
                  }}</span
                >
              </div>
              <div class="table-child">
                个数
                <Input
                  v-model="offlineChild.orderNum"
                  style="width: 1.4rem; margin: 0 0.1rem"
                  @on-change="changeNumber(offlineChild)"
                  maxlength="4"
                  type="number"
                />
                {{ offlineChild.cunit }}
              </div>
              <div class="table-child">
                总价: {{ offlineChild.orderNum * offlineChild.price }}
                {{ offlineChild.pType }}
              </div>
            </div>

            <div
              style="width: 100%; height: 1px; background-color: #e5e5e5"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 0.5rem 0.3rem; font-size: 0.3rem; color: #666">
      <div>线上线下市场增值服务订单小计：{{ price }}元</div>

      <div>展位订单小计：{{ boothprice || 0 }}元</div>
      <div>固定费用：{{ gudingprice }}元</div>
      <div>订单合计：{{ price + boothprice + gudingprice }}元</div>
    </div>
    <div class="submitbtn">
      <div class="btn" @click="submit" v-if="!display">
        <span>确定并提交申请</span>
      </div>
      <div class="btn-dis" v-else>
        <span>确定并提交申请</span>
      </div>
    </div>
  </div>
</template>

<script>
// (function () {
//   function w() {
//     var r = document.documentElement;
//     var a = r.getBoundingClientRect().width; //获取当前设备的宽度
//     if (a > 750) {
//       //720不固定，根据设计稿的宽度定
//       a = 750;
//     }
//     let rem = a / 7.5;
//     r.style.fontSize = rem + "px";
//   }
//   w();
//   window.addEventListener(
//     "resize",
//     function () {
//       //监听横竖屏切换
//       w();
//     },
//     false
//   );
// })();

import { mapActions } from "vuex";
let moment = require("moment");
export default {
  name: "index",
  data() {
    return {
      exIndex: 0,
      exAreaIndex: 0,
      company: "",
      name: "",
      job: "",
      phone: "",
      Email: "",
      address: "",
      DePjName: "",
      UnitPrice: "",
      Unit: "",
      exarea: 1, //面积
      inputShow: false,
      other: "",
      price: 0,
      gudingprice: 0,
      boothprice: 0,
      creditCode: "",
      exhibitionName: "",
      exhibitionId: "", //展会ID
      exhibitionAreaId: "", //展区ID
      exhibitionList: [], //展会列表
      exhibitionArea: [], //展区列表
      exhibitionBooth: [], //展位列表
      otherList: [], //固定费用列表
      onlineList: [], //线上费用
      offlineList: [], //线下
      chooseArr: [], //选择的增值服务
      boothSelect: [], //选中的展位
      applyCompanyId: "",
      applyCompanyOrderId: "",
      chooseOtherArr: [], //选中的其他订单
      inputShow: false,
      remark: "",
      fixId: "",
      display: false, //按钮禁用
      changeLoading: false, //切换
    };
  },
  components: {},
  computed: {},
  created() {
    document.title = "tHIS ASEAN Stand Application";
    this.init();
  },
  methods: {
    ...mapActions({
      ApplyScene: "ApplyScene",
      getApplyExhibitionByIndex: "getApplyExhibitionByIndex",
      getDePjNameGroup: "getDePjNameGroup",
      addApplyCompany: "addApplyCompany", //提交基本信息
      applyCompanyOrder: "applyCompanyOrder", //获取订单ID
      addApplyOrder: "addApplyOrder",
      finishApplyOperate: "finishApplyOperate",
    }),
    getboothPrice() {
      if (
        this.boothSelect &&
        this.boothSelect.standstall > 1 &&
        (this.boothSelect.cunit.indexOf("㎡") != -1 ||
          this.boothSelect.cunit.indexOf("平米") != -1 ||
          this.boothSelect.cunit.indexOf("平方米") != -1)
      ) {
        this.boothprice = parseInt(
          (
            (this.boothSelect.Width *
              this.boothSelect.Height *
              this.boothSelect.price) /
            this.boothSelect.standstall
          ).toFixed()
        );
      } else {
        this.boothprice = parseInt(
          this.boothSelect.Width *
            this.boothSelect.Height *
            this.boothSelect.price
        );
      }
    },
    exwidth(width) {
      this.boothSelect.Width = width;
      if (width) {
        this.getboothPrice();
      }
    },
    exheight(height) {
      this.boothSelect.Height = height;
      if (height) {
        this.getboothPrice();
      }
    },
    changeNumber(item) {
      this.price = 0;
      this.chooseArr.forEach((e) => {
        if (e.orderNum && e.price) {
          this.price += e.orderNum * e.price;
        }
      });
    },
    //选择线上订单
    onlineChange(item, e) {
      this.price = 0;
      if (e) {
        this.chooseArr.push(item);
      } else {
        this.chooseArr.splice(this.chooseArr.indexOf(item.id), 1);
      }

      this.chooseArr.forEach((e) => {
        if (e.orderNum && e.price) {
          this.price += e.orderNum * e.price;
        }
      });
    },
    //选择线下订单
    offlineChange(item, e) {
      this.price = 0;
      if (e) {
        this.chooseArr.push(item);
      } else {
        this.chooseArr.splice(this.chooseArr.indexOf(item.id), 1);
      }
      this.chooseArr.forEach((e) => {
        if (e.orderNum && e.price) {
          this.price += e.orderNum * e.price;
        }
      });
      console.log(this.chooseArr);
    },
    //获取展位订单信息
    getExhibitionBooth() {
      if (
        this.exhibitionArea.length > 0 &&
        this.exhibitionArea[this.exAreaIndex].dePjNameList.length > 0
      ) {
        this.exhibitionBooth =
          this.exhibitionArea[this.exAreaIndex].dePjNameList;
        this.exhibitionBooth.map((e) => {
          e.isCheck = false;
          e.Width = 0;
          e.Height = 0;
        });
      }
    },
    //获取固定订单
    async getOtherList() {
      this.gudingprice = 0;
      let otherList3 = await this.getDePjNameGroup({
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "固定费用",
      });
      if (otherList3 && otherList3.length > 0) {
        otherList3.forEach((e) => {
          if (e.typeLanguage == "中文" && e.dePjNameList.length > 0) {
            e.dePjNameList.forEach((c) => {
              this.fixId = c.dePjNameGroupId;
              c.isCheck = true;
              this.gudingprice += c.minCount * c.price;
            });

            this.otherList = e.dePjNameList;
          }
        });
        this.otherList.forEach((c) => {
          console.log(c, "ccc");
          this.chooseArr.push(c);
        });
      }
    },
    async geOnlineList() {
      let otherList = await this.getDePjNameGroup({
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "线上",
      }); // 是：展区选择展位； 否：增值服务项目
      console.log(otherList, "otherList");
      if (otherList && otherList.length > 0) {
        otherList.map((c) => {
          c.isPack = false;
          c.isCheck = false;

          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map((d) => {
              d.orderNum = 0;
              d.durationValue = null;
              d.otherName = c.name;
              (d.beginTime = ""), (d.endTime = "");
              let start = new Date(d.durationBegin).getTime();
              let end = new Date(d.durationEnd).getTime();
              d.options = {
                disabledDate(date) {
                  const disabledDay = date.getTime();
                  if (disabledDay < start || disabledDay > end) {
                    return true;
                  } else {
                    return false;
                  }
                },
              };
            });
          }
        });
      }
      this.onlineList = otherList;
      this.onlineList.map((a) => {
        if (a.dePjNameList.length > 0) {
          a.dePjNameList.map((p) => {
            if (p.netShow == "显示且必选") {
              p.orderNum = 1;
              //this.chooseOne(p)
            }
          });
        }
      });
      console.log(this.onlineList, "线上");
    },
    //获取线下数组
    async geOfflineList() {
      let otherList = await this.getDePjNameGroup({
        IsBoothGroup: "否",
        ExhibitionId: this.exhibitionId,
        Type: "线下",
      }); // 是：展区选择展位； 否：增值服务项目

      if (otherList && otherList.length > 0) {
        otherList.map((c) => {
          c.isPack = false;
          c.isCheck = false;

          if (c.dePjNameList.length > 0) {
            c.dePjNameList.map((d) => {
              d.orderNum = 0;
              d.durationValue = null;
              d.otherName = c.name;
              (d.beginTime = ""), (d.endTime = "");
              let start = new Date(d.durationBegin).getTime();
              let end = new Date(d.durationEnd).getTime();
              d.options = {
                disabledDate(date) {
                  const disabledDay = date.getTime();
                  if (disabledDay < start || disabledDay > end) {
                    return true;
                  } else {
                    return false;
                  }
                },
              };
            });
          }
        });
      }
      this.offlineList = otherList;
      this.offlineList.map((a) => {
        if (a.dePjNameList.length > 0) {
          a.dePjNameList.map((p) => {
            if (p.netShow == "显示且必选") {
              p.orderNum = 1;
              //this.chooseOne(p)
            }
          });
        }
      });
      console.log(this.offlineList, "线上");
    },
    //获取展会
    async getExhibition() {
      let idsToDelete = [
        "ebd24211-4119-4b47-afb2-9647c325ebab",
        "a3741b45-d5ee-46dc-8a94-2e2577ad5ee0",
        "ab24aee3-ad4f-438c-9f8f-4816d2ef0865",
      ];

      let list = await this.getApplyExhibitionByIndex();
      let listNew = JSON.parse(JSON.stringify(list));
      listNew.forEach((element, index) => {
        if (element.id == "949e3761-b303-4597-8bec-3f206913a86d") {
          list.splice(index, 1);
        }
      });
      this.exhibitionList = list.filter((obj) => !idsToDelete.includes(obj.id));
      this.exhibitionId = this.exhibitionList[0].id;

      if (this.exhibitionId) {
        this.getExhibtionArea(this.exhibitionId);
        this.getOtherList();
        this.geOnlineList();
        this.geOfflineList();
      }
    },
    //获取展会的展区
    async getExhibtionArea(id) {
      // 展位、增值服务
      let list = await this.getDePjNameGroup({
        IsBoothGroup: "是",
        ExhibitionId: id,
      });
      if (list) {
        list.sort(function (a, b) {
          return a.showIndex - b.showIndex;
        });

        this.exhibitionArea = list;
        this.exhibitionAreaId = list[0].id;
        this.changeLoading = false;
      }
      this.getExhibitionBooth();
    },
    //改变展会
    changeEx(id, index) {
      if (this.changeLoading == true) {
        return;
      }
      this.changeLoading = true;

      this.exhibitionArea = [];
      this.inputShow = false;
      this.exIndex = index;
      this.exhibitionId = id;
      this.getExhibtionArea(id);
      console.log(this.exhibitionArea);
      if (
        this.exhibitionArea.length > 0 &&
        this.exhibitionArea[0].name.indexOf("其他") !== -1
      ) {
        this.inputShow = true;
      } else {
        this.inputShow = false;
      }
      this.exAreaIndex = 0;
      this.price = 0;
      this.boothprice = 0;
      this.boothSelect = [];
      this.chooseArr = [];

      this.getOtherList();
      this.geOnlineList();
      this.geOfflineList();
    },
    //改变展区
    changeExArea(id, index, name) {
      this.exhibitionAreaId = id;
      this.exAreaIndex = index;
      this.price = 0;
      this.boothprice = 0;
      this.boothSelect = [];
      this.chooseArr = [];
      if (name.indexOf("其他") !== -1) {
        this.inputShow = true;
      } else {
        this.inputShow = false;
      }
      this.getExhibitionBooth();
      this.getOtherList();
      this.geOnlineList();
      this.geOfflineList();
    },
    changeBox(item, e, index) {
      let arr = this.exhibitionBooth;
      arr.forEach((c) => {
        c.isCheck = false;
        if (item.id == c.id) {
          c.isCheck = e;
        }
      });

      this.$nextTick(() => {
        this.exhibitionBooth = JSON.parse(JSON.stringify(arr));
      });
      this.boothSelect = item;
      this.boothprice = 0;

      console.log(this.boothSelect);
    },
    async init() {
      this.getExhibition();
    },

    //校验邮箱格式
    checkEmail(email) {
      return RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(
        email
      );
    },
    checkPhone(phone) {
      return RegExp(11 && /^1\d{10}$/).test(phone);
    },

    //根据错误定位
    goFail(ElepropName) {
      Element.prototype.documentOffsetTop = function () {
        return (
          this.offsetTop +
          (this.offsetParent ? this.offsetParent.documentOffsetTop() : 0)
        );
      };
      console.log(ElepropName, "ElepropName");
      let top =
        document.getElementById(ElepropName).documentOffsetTop() -
        window.innerHeight / 2;
      window.scrollTo(0, top);
      return;
    },
    //基本信息报名
    async apply() {
      this.display = true;
      let req = {
        companyName: this.company,
        linkMan: this.name,
        linkTitle: this.job,
        linkMob: this.phone,
        linkEmail: this.Email,
        address: this.address,
        leaderEmail: this.Email,
        unifiedCode: this.creditCode,
      };
      let bool = await this.addApplyCompany(JSON.stringify(req));
      if (bool && bool.successed) {
        this.applyCompanyId = bool.info;
        this.applyEx();
      } else {
        this.display = false;
      }
    },
    //直销展位报名
    async applyEx() {
      let req = {
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: this.exhibitionId,
        IsAgent: "否",
        AgentName: "",
      };
      let bool = await this.applyCompanyOrder(req);
      if (bool && bool.successed) {
        this.applyCompanyOrderId = bool.info.id;
        this.applyOrder();
      } else {
        this.display = false;
        this.$Message.warning("您已完成报名请耐心等待组委会通知");
      }
    },
    //创建展位订单
    async applyOrder() {
      let ApplyOtherOrderList = [];
      console.log(this.chooseArr, "chooseArr");
      this.chooseArr = Array.from(new Set(this.chooseArr));

      if (this.chooseArr && this.chooseArr.length > 0) {
        this.chooseArr.map((c) => {
          if (c.durationType === "时长") {
            ApplyOtherOrderList.push({
              ApplyCompanyOrderId: this.applyCompanyOrderId,
              DePjNameGroupId: c.dePjNameGroupId,
              DePjNameGroupName: c.otherName,
              Name: c.pjName,
              Quantity: c.orderNum,
              Unit: c.cunit,
              UnitPrice: c.price,
              TotalPrice: c.orderNum * c.price,
              MonetaryUnit: c.pType,
              DurationType: c.durationType,
              Duration: Number(c.durationValue),
              DurationUnit: c.durationUnit,
              RexMoney: c.orderNum * c.price,
              GpName: c.gpName || "",
              GpCode: c.gpCode || "",
              PjCode: c.pjCode || "",
              GroupId: c.groupId || "",
              PjFormat: c.pjFormat || "",
            });
          }
          if (c.durationType === "时间段") {
            ApplyOtherOrderList.push({
              ApplyCompanyOrderId: this.applyCompanyOrderId,
              DePjNameGroupId: c.dePjNameGroupId,
              DePjNameGroupName: c.otherName,
              Name: c.pjName,
              Quantity: c.orderNum,
              Unit: c.cunit,
              UnitPrice: c.price,
              TotalPrice: c.orderNum * c.price,
              MonetaryUnit: c.pType,
              DurationType: c.durationType,
              DurationBegin: moment(c.beginTime).format("YYYY-MM-DD"),
              DurationEnd: moment(c.endTime).format("YYYY-MM-DD"),
              RexMoney: c.orderNum * c.price,
              GpName: c.gpName || "",
              GpCode: c.gpCode || "",
              PjCode: c.pjCode || "",
              GroupId: c.groupId || "",
              PjFormat: c.pjFormat || "",
            });
          } else if (c.dePjNameGroupId == this.fixId) {
            ApplyOtherOrderList.push({
              ApplyCompanyOrderId: this.applyCompanyOrderId,
              DePjNameGroupId: c.dePjNameGroupId,
              DePjNameGroupName: "固定费用",
              Name: c.pjName,
              Quantity: 1,
              Unit: c.cunit,
              UnitPrice: c.price,
              TotalPrice: c.price,
              MonetaryUnit: c.pType,
              DurationType: c.durationType,
              DurationBegin: moment(c.durationBegin).format("YYYY-MM-DD"),
              DurationEnd: moment(c.durationEnd).format("YYYY-MM-DD"),
              RexMoney: c.price,
              GpName: c.gpName || "",
              GpCode: c.gpCode || "",
              PjCode: c.pjCode || "",
              GroupId: c.groupId || "",
              PjFormat: c.pjFormat || "",
            });
          }
        });
      }

      const hash = {};
      const newArray = ApplyOtherOrderList.reduce((item, next) => {
        hash[next.PjCode] ? "" : (hash[next.PjCode] = true && item.push(next));
        return item;
      }, []);
      console.info("去重后的数组:", newArray);
      if (this.boothprice == 0) {
        this.$Message.fail("展位金额计算失败，请刷新后再试...");
        return;
      }
      ApplyOtherOrderList = newArray;
      let req = {
        Id: this.applyCompanyOrderId,
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: this.exhibitionId,
        IsAgent: "否",
        Remark: this.remark,
        ApplyBoothOrderList: [
          {
            ApplyCompanyOrderId: this.applyCompanyOrderId,
            DePjNameGroupId: this.exhibitionAreaId,
            DePjNameGroupName: this.exhibitionArea[this.exAreaIndex].name,
            Name: this.boothSelect.pjName,
            Width: this.boothSelect.Width,
            Height: this.boothSelect.Height,
            Area: this.boothSelect.Width * this.boothSelect.Height,
            Unit: this.boothSelect.cunit,
            UnitPrice: this.boothSelect.price,
            TotalPrice: this.boothprice,
            MonetaryUnit: this.boothSelect.pType,
            IsAgent: "否",
            RexMoney:
              this.boothSelect.Width *
              this.boothSelect.Height *
              this.boothSelect.price,
            GpName: this.boothSelect.gpName || "",
            GpCode: this.boothSelect.gpCode || "",
            PjCode: this.boothSelect.pjCode || "",
            GroupId: this.boothSelect.groupId || "",
            PjFormat: this.boothSelect.pjFormat || "",
            BoothType: this.boothSelect.boothType || "",
          },
        ],
        ApplyOtherOrderList: ApplyOtherOrderList,
      };
      if (
        this.boothSelect.standstall > 1 &&
        (this.boothSelect.cunit.indexOf("㎡") != -1 ||
          this.boothSelect.cunit.indexOf("平米") != -1 ||
          this.boothSelect.cunit.indexOf("平方米") != -1)
      ) {
        req.ApplyBoothOrderList[0].TotalPrice = (
          (this.boothSelect.Width *
            this.boothSelect.Height *
            this.boothSelect.price) /
          parseInt(this.boothSelect.standstall)
        ).toFixed();

        req.ApplyBoothOrderList[0].RexMoney = (
          (this.boothSelect.Width *
            this.boothSelect.Height *
            this.boothSelect.price) /
          parseInt(this.boothSelect.standstall)
        ).toFixed();
      }

      let info = await this.addApplyOrder(req);
      if (info && info.successed) {
        this.finished();
      } else {
        this.display = false;
        this.$Message.fail("提交失败");
      }
    },
    async finished() {
      let req = {
        Id: this.applyCompanyOrderId,
        // ApplyFileLink: this.uploadList[0].url
        ApplyFileLink: "finished",
      };
      let bool = await this.finishApplyOperate(req);
      if (bool && bool.successed) {
        this.display = false;
        this.$Message.success("提交成功！");
        setTimeout(() => {
          this.$router.push({ path: "/HomeMobile-success" });
        }, 1500);
      } else {
        this.display = false;
        this.$Message.fail("提交失败");
      }
    },
    async submit() {
      console.log(this.exhibitionAreaId, "exhibitionAreaId");
      if (!this.company) {
        this.$Message.info("请输入公司名称");
        this.goFail("company");

        return;
      }
      if (!this.name) {
        this.$Message.info("请输入联系人姓名");
        this.goFail("name");

        return;
      }
      if (!this.job) {
        this.$Message.info("请输入联系人职位");
        this.goFail("job");

        return;
      }
      if (!this.phone) {
        this.$Message.info("请输入联系人手机号");
        this.goFail("phone");

        return;
      } else {
        let bool = this.checkPhone(this.phone);
        if (!bool) {
          this.$Message.info("请正确的手机号");
          return;
        }
      }

      if (!this.Email) {
        this.$Message.info("请输入邮箱");
        this.goFail("email");

        return;
      } else {
        let bool = this.checkEmail(this.Email);
        if (!bool) {
          this.$Message.info("请正确的邮箱");
          return;
        }
      }

      if (!this.address) {
        this.$Message.info("请输入地址");
        this.goFail("address");

        return;
      }
      if (!this.creditCode) {
        this.$Message.info("请输入社会信用代码");
        this.goFail("creditCode");
        return;
      } else {
        if (
          this.creditCode.length === 15 ||
          this.creditCode.length === 18 ||
          this.creditCode.length === 20
        ) {
        } else {
          this.$Message.info("请输入正确的社会信用代码");
          return;
        }
      }

      if (this.boothSelect.length < 1) {
        this.$Message.info("请选择一个展位类型");
        this.goFail("booth");
        this.display = false;
        return;
      }
      if (this.boothSelect.Width == 0 || this.boothSelect.Height == 0) {
        this.$Message.warning("请输入展位宽度和进深");
        this.display = false;
        return;
      }

      if (this.chooseArr && this.chooseArr.length > 0) {
        let finish = true;
        this.chooseArr.map((c) => {
          if (!c.durationValue && c.durationType == "时长") {
            finish = false;
            this.$Message.warning("请选择" + c.pjName + "的" + c.durationType);
            return;
          }
          if (
            c.durationType === "时间段" &&
            (!c.beginTime || !c.endTime) &&
            c.durationType != "无"
          ) {
            finish = false;
            this.$Message.warning("请选择" + c.pjName + "的" + c.durationType);
            return;
          }
          if (!c.orderNum && c.dePjNameGroupId != this.fixId) {
            finish = false;
            this.$Message.warning("请输入" + c.pjName + "的订购数量");
            return;
          }
        });
        console.log(this.chooseArr, "数组改变没");

        if (!finish) return;
      }
      if (this.inputShow && !this.remark) {
        console.log(this.remark);
        this.$Message.warning("请输入产品类型");
        this.display = false;
        return;
      }

      this.apply();
      //   if (res.successed) {
      //     this.$router.push({ path: "/HomeMobile-success" });
      //   }
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  font-size: 0.24rem;
  height: 0.5rem;
  line-height: 0.5rem;
}
/deep/.ivu-select-item {
  font-size: 0.24rem !important;
}
/deep/.ivu-select-single .ivu-select-selection {
  height: 0.5rem;
}
/deep/.ivu-select {
  font-size: 0.24rem;
}
/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.24rem;
}
/deep/ .ivu-input {
  font-size: 0.24rem;
}
/deep/ .ivu-checkbox-checked .ivu-checkbox-inner:after {
  width: 10px;
  height: 16px;
  left: 10px;
}
/deep/ .ivu-checkbox {
  .ivu-checkbox-inner {
    width: 0.3rem;
    height: 0.3rem;
  }
}
::v-deep {
  .ivu-input {
    height: 0.8rem;
  }
}

.header {
  height: 1rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  span {
    font-size: 0.3rem;
  }
}
.title {
  font-size: 0.3rem;
  color: #353535;
  background-color: #f2f2f2;
  padding: 0.36rem 0 0.25rem 0.3rem;
}
.content {
  padding: 0 0.3rem;
  .cell {
    padding: 0.24rem 0;
    border-bottom: 1px solid #e5e5e5;
    span {
      color: #353535;
      font-size: 0.3rem;
      width: 2.8rem;
      display: inline-block;
    }
    input {
      border: 0px;
      outline: none;
      width: 3.5rem;
    }
  }
}
.exhibitionarea {
  padding: 0.3rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -0.28rem;
  .exhibition1 {
    background-color: #fff;
    border-radius: 0.1rem;
    border: solid 1px #e6e6e6;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.2rem;
    margin-left: 0.28rem;
    padding: 0.2rem;
    .span1 {
      font-size: 0.24rem;
      color: #666;
    }
    &.is_active {
      border: solid 1px #ff5c00;
      .span1 {
        color: #ff5c00;
      }
    }
  }
}
.reserve {
  padding-left: 0.3rem;
  margin-top: 0.3rem;
  font-size: 0.26rem;
  position: relative;
  .reserve_span1 {
    color: #353535;
  }
  .reserve_span2 {
    color: #999;
  }
  .reserve_span3 {
    position: absolute;
    right: 0.2rem;
  }
  .selectInput {
    display: flex;
    align-items: center;
    margin-top: 0.15rem;
    margin-bottom: 0.2rem;
  }
  .icon {
    transform: scale(2);
    color: #666;
  }
  .icon_dis {
    color: #e5e5e5;
  }
}
.submitbtn {
  background-color: #f2f2f2;
  padding: 0.95rem 0.3rem 0.4rem;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.88rem;
    background-color: #fe781d;
    border-radius: 0.05rem;

    span {
      font-size: 0.3rem;
      color: #fff;
    }
  }
  .btn-dis {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.88rem;
    background-color: #f5f5f5;
    border-radius: 0.05rem;

    span {
      font-size: 0.3rem;
      color: #fff;
    }
  }
}
.ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #2d8cf0;
  background-color: #2d8cf0;
}
.ivu-checkbox-checked:hover .ivu-checkbox-inner {
  border-color: #2d8cf0;
}
.area {
  margin-top: 0.5rem;
  padding-left: 0.3rem;
  font-size: 0.24rem;
  &-title {
    color: #353535;
    font-size: 0.26rem;
  }
  input {
    font-size: 0.24rem;
    height: 64px;
  }
}
.cell {
  input {
    font-size: 0.24rem;
  }
}
.careful {
  color: red;
  font-size: 0.24rem;
  text-align: center;
}
.table {
  font-size: 0.24rem;
  padding-left: 0.7rem;
  &-child {
    margin-top: 0.4rem;
  }
}
.loadingText {
  font-size: 0.24rem;
  text-align: center;
  padding: 0.2rem;
}
</style>

